import React from 'react';
import { useLocation, createBrowserRouter, createHashRouter, createMemoryRouter, RouterProvider, } from "react-router-dom";
import Root from "./components/Root";
import MainMenu from "./components/MainMenu";
import ComputerMenu from "./components/ComputerMenu";
import About from "./components/About";
import Achievements from "./components/Achievements";
import Game from "./components/Game";
import Statistics from "./components/Statistics";
import HowToPlay from "./components/HowToPlay";
import Settings from "./components/Settings";
import Loading from "./components/Loading";
import MoreGames from "./components/MoreGames";
import Test from "./components/Test";
import { AppContext } from './AppContext';


export default function App({application}) {
  const app = application;

  app.onNavigate = (path) => {
    window.location.hash = path;
    router.navigate("/" + path);
  }
  window.addEventListener('hashchange', () => {
    const path = window.location.hash.substring(1); //remove hash
    app.navigate(path);
  });
  
  const router = createMemoryRouter([ 
    {
      path: "/",
      element: <Root />,
      children: [
        { index: true, path: "/", element: <MainMenu /> },
        { path: "/MainMenu", element: <MainMenu /> },
        { path: "ComputerMenu", element: <ComputerMenu /> },
        { path: "About", element: <About /> },
        { path: "Achievements", element: <Achievements /> },
        { path: "Game/:mode/:level", element: <Game /> },
        { path: "Statistics", element: <Statistics /> },
        { path: "HowToPlay", element: <HowToPlay /> },
        { path: "Settings", element: <Settings /> },
        { path: "Loading", element: <Loading /> },
        { path: "MoreGames", element: <MoreGames /> },
        { path: "Test", element: <Test /> },
      ]
    }
  ]);
  window.location.hash = ""; //init hash
  router.navigate("/" + app.pageId);

  return (
    <AppContext.Provider value={app}>
      <RouterProvider router={router} fallbackElement={<p>Loading...</p>} />
    </AppContext.Provider>
  );
}

if (import.meta.hot) {
  import.meta.hot.dispose(() => router.dispose());
}